import { render, staticRenderFns } from "./SeStdTaxForm1040s1.vue?vue&type=template&id=224127c2"
import script from "./SeStdTaxForm1040s1.vue?vue&type=script&lang=js"
export * from "./SeStdTaxForm1040s1.vue?vue&type=script&lang=js"
import style0 from "./SeStdTaxForm1040s1.vue?vue&type=style&index=0&id=224127c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports